<style lang="scss" scoped>
.advertisement {
  width: 401px;
  height: 47px;
  background: rgba(255, 255, 255, 0.1);
  position: relative;

  display: flex;
  align-items: center;
  .icon {
    position: absolute;
    width: 30px;
    height: 30px;
    background-image: url("./assets/icon.png");
    background-size: 100% 100%;
    left: 15px;
    top: 4px;
  }
  .content {
    width: 317px;
    height: 20px;
    margin-left: 56px;
    font-size: 16px;
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>

<template>
  <div class="advertisement">
    <div class="icon"></div>
    <el-tooltip effect="dark" :content="content" placement="top">
      <div class="content">
        {{ content }}
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "advertisement",
  props: {
    content: String,
  },
};
</script>
